import { useAuth } from 'context/AuthProvider';
import useApi from 'hooks/useApi';
import { useEffect, useState } from 'react';
import { apiHorariosService } from 'services/apiHorariosService';
import ListHorarios from './ListHorarios';

const ListHorariosImpl = () => {

  const {empresa} = useAuth();
  const [content, setContent] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  
  //const { data, loading, error } = useApi(apiHorariosService.getAllPageable(empresa.id,currentPage,10));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () =>{
      const response = await apiHorariosService.getAllPageable(empresa.id,currentPage,10)
       
      setContent(response.content);
      setTotalPage(response.totalPages);
    }
    setLoading(true)
    fetchData();
    setLoading(false)
  }, []);


  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
   <ListHorarios horarios={content} currentPage={currentPage} setCurrentPage={setCurrentPage} totalPage={totalPage}/>
   </>
  );
}


export default ListHorariosImpl